// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xv_a bhs_a bhs_x","StrollerDetailRating__muted":"xv_b bhs_fi"};